(function() {
  document.querySelectorAll('.product__description--text').forEach(function(container) {
    var html = container.innerHTML.trim();
    if (!html || html.length < 200) return;

    // Wrap original content in full-description div
    var fullDiv = document.createElement('div');
    fullDiv.className = 'full-description';
    fullDiv.innerHTML = html;

    // Create toggle button
    var btn = document.createElement('button');
    btn.className = 'toggle-description';
    btn.textContent = 'Read More';

    // Replace container content
    container.innerHTML = '';
    container.appendChild(fullDiv);
    container.appendChild(btn);

    // Toggle handler
    btn.addEventListener('click', function(e) {
            e.stopPropagation();
                  e.preventDefault();
      container.classList.toggle('is-expanded');
      btn.textContent = container.classList.contains('is-expanded') ? 'Read Less' : 'Read More';
    });
  });
})();